const SECTOR_STRATEGY_BASE_PATH = "/api/algotrade/sector-strategy";
const SECTOR_STRATEGY_EXECUTION_BASE_PATH =
  "/api/algotrade/sector-strategy-execution";

export const SectorStrategyApiUrl = {
  basePath: SECTOR_STRATEGY_BASE_PATH,
  save: "/save-sector-strategy",
  update: "/update-sector-strategy",
  getByUser: "/get-sector-strategies-by-user-id",
  getById: "/get-sector-strategy-by-id",
  executionBasePath: SECTOR_STRATEGY_EXECUTION_BASE_PATH,
  capabilities: "/capabilities",
  trades: "/trades",
  entryCalculations: "/entry-calculations",
  candidates: "/candidates",
  history: "/history",
  performance: "/performance",
  squareOff: "/square-off",
  squareOffStrategy: "/square-off-strategy",
};
